import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ListaItem } from '../models/lista-item';

@Injectable()
export class ListaItemService {

  private urlListaIteEndPoint = environment.listaItemEndPoint;

  constructor(private http: HttpClient) { }

  listaItemsPorCodigoLista(codigo: string): Observable<ListaItem[]> {
    return this.http.get(this.urlListaIteEndPoint + 'codigolista/' + codigo).pipe(
      map((respuesta) => respuesta as ListaItem[]),
    );
  }

  listaItemsPorCodigoListaHabilitado(codigo: string): Observable<ListaItem[]> {
    return this.http.get(this.urlListaIteEndPoint + 'codigolista/habilitado/' + codigo).pipe(
      map((respuesta) => respuesta as ListaItem[]),
    );
  }

  ambientesPorCompaniaSede(idCompania: number, idSede: number): Observable<ListaItem[]> {
    return this.http.get(this.urlListaIteEndPoint + 'ambientes/compania/' + idCompania +
      '/sede/' + idSede).pipe(
        map((respuesta) => respuesta as ListaItem[])
      );
  }

  ambientesPorCompaniaSedeValidaDMZ(idCompania: number, idSede: number): Observable<ListaItem[]> {
    return this.http.get(this.urlListaIteEndPoint + 'ambientesDMZ/compania/' + idCompania +
      '/sede/' + idSede).pipe(
        map((respuesta) => respuesta as ListaItem[])
      );
  }

  listaItemsPorCodigoValor(codigo: string, valor: string): Observable<ListaItem[]> {
    return this.http.get(this.urlListaIteEndPoint + 'codigolista/' + codigo + '/valor/' + valor).pipe(
      map((respuesta) => respuesta as ListaItem[]),
    );
  }

  guardarListaItem(listaItem: ListaItem): Observable<ListaItem> {
    return this.http.post(this.urlListaIteEndPoint + 'guardar', listaItem, {responseType: 'json'}).pipe(
      map((resultado) => resultado as ListaItem)
    );
  }

  editarListaItem(listaItem: ListaItem): Observable<ListaItem> {
    return this.http.post(this.urlListaIteEndPoint + 'editar', listaItem, {responseType: 'json'}).pipe(
      map((resultado) => resultado as ListaItem)
    );
  }

  public async guardarListaAsync(listaItem: ListaItem): Promise<ListaItem> {
    return this.http.post(this.urlListaIteEndPoint + 'guardar', listaItem, {responseType: 'json'}).toPromise().then(
      res => res as ListaItem
    );
  }

  public listarMascarasConfiguradas(): Observable<ListaItem[]> {
    return this.http.get(this.urlListaIteEndPoint + 'mascaras/configuradas').pipe(
      map((respuesta) => respuesta as ListaItem[])
    );
  }

  public listaItemPorCodigos(codigoItem: string, codigoLista: string): Observable<ListaItem> {
    return this.http.get(this.urlListaIteEndPoint + 'codigos/' + codigoItem + '/' + codigoLista).pipe(
      map((respuesta) => respuesta as ListaItem)
    );
  }

  public async maximoCodigoLista(idLista: number): Promise<number> {
    return this.http.get(this.urlListaIteEndPoint + 'codigos/maximo/' + idLista).toPromise().then(
      respuesta => respuesta as number
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/lista-item.service.ts